var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"douKuaiCell"},[(_vm.row[_vm.column.key])?_c('span',[_vm._v("已失效")]):_vm._e(),(_vm.row['export_status'] === 1 && !_vm.row[_vm.column.key])?_c('a',{attrs:{"href":_vm.row['download_url']}},[_vm._v("下载")]):_vm._e(),(_vm.row['export_status'] !== 1)?_c('span',{staticClass:"mr-8"},[_vm._v("--")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }